import ServiceCard from './ServiceCard';

interface PropertyServiceFormData {
  id?: number | string;
  name: string;
  slug: string;
  description?: string;
  image?: string;
  image_gallery?: string[];
  sort_order?: number;
  is_active?: boolean;
}

interface ServiceListProps {
  services: PropertyServiceFormData[];
  hoveredId: string | null;
  onServiceHover: (id: string | null) => void;
}

export default function ServiceList({ services, hoveredId, onServiceHover }: ServiceListProps) {
  return (
    <div className="h-full overflow-y-auto px-6 py-6">
      <div className="mb-4">
        <h2 className="text-2xl font-bold text-gray-900">
          {services.length} {services.length === 1 ? 'service' : 'services'} available
        </h2>
        <p className="text-sm text-gray-600 mt-1">
          Discover our comprehensive range of property services
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 pb-6">
        {services.map((service) => (
          <ServiceCard
            key={service.id ?? service.name}
            service={service}
            isHovered={hoveredId === service.id}
            onHover={() => onServiceHover(service.id?.toString() ?? null)}
            onLeave={() => onServiceHover(null)}
          />
        ))}
      </div>
    </div>
  );
}
